import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { Avatar } from 'primereact/avatar';
import { Divider } from "primereact/divider";
import { Menu } from "primereact/menu";
import { Message } from "primereact/message";
import { Tooltip } from "primereact/tooltip";
import { Fragment, useEffect, useRef, useState } from "react";
import { FaUser } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LogoImg from "../../assests/MarsPetcareLogo2.png";
import { loginRequest } from '../../auth.config';
import { SET_NOTIFICATION_ARRAY } from "../../redux/crumbs/crumbs.type";
import { ActionText, HeaderComp, LogoText } from "./headerStyle";


function Header() {
    const navigate = useNavigate()
    const { sessionData } = useSelector((state) => state.crumbs)
    const dispatch = useDispatch()
    const { accounts, instance } = useMsal();
    const menuLeft = useRef(null);
    const [photo, setPhoto] = useState(null);
    const bellMenu = useRef(null);
    const [countNoti, setCountNoti] = useState(0);

    const handleLogout = () => {
        instance.logoutPopup()
            .then(() => {
                window.location.reload();  // Optional: Reload page after logout to reset the UI state
            })
            .catch((error) => {
                console.error("Logout error: ", error);
            });
    };
    const getProfilePhoto = async () => {
        try {
            // Ensure you acquire a token for the signed-in user
            const response = await instance.acquireTokenSilent({
                ...loginRequest,
                account: accounts[0],  // Use the first account from the authenticated accounts
            });

            const token = response.accessToken;

            // Fetch the profile photo
            const photoResponse = await axios.get(
                'https://graph.microsoft.com/v1.0/me/photo/$value',
                {
                    headers: {
                        Authorization: `Bearer ${token}`,  // Pass the token in the Authorization header
                    },
                    responseType: 'arraybuffer',  // To receive the image as binary data
                }
            );

            const blob = new Blob([photoResponse.data], { type: 'image/jpeg' });
            const imageUrl = URL.createObjectURL(blob);
            setPhoto(imageUrl);
        } catch (err) {
            console.error('Error fetching profile photo', err);
        }
    };
    const getBellNotification = () => {
        // let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
        let displayMessages = []
        if (sessionData.bellNotification?.length !== 0) {
            sessionData.bellNotification?.map((val, index1) => {
                // let match = 0
                // sessionData.bellNotification.map((val1, index2) => {

                //     if (val === val1 && index1 > index2) {
                //         match = 1
                //     }
                // })
                // if (match === 0) {
                displayMessages.push({ label: <Message severity="info" text={<span style={{ padding: "0", margin: "0", fontSize: "11px" }}>{val}</span>} /> })
                // }
            })
            return [
                {
                    // label: localStorage.getItem("userName"),
                    items: displayMessages
                }
            ]
        } else {
            return [
                {
                    label: "No Notification available",
                    // items: displayMessages
                }
            ]
        }



    }
    useEffect(() => {
        let tempArray = JSON.parse(sessionStorage.getItem('bellNotification'));
        dispatch({
            type: SET_NOTIFICATION_ARRAY,
            payload: {
                value: tempArray
            }
        })
        getProfilePhoto()
    }, [])
    useEffect(() => {
        setCountNoti(sessionData.bellNotification?.length)
    }, [sessionData.bellNotification])
    return (<Fragment>
        <HeaderComp>
            <div class="grid" style={{ height: "100%", padding: "0px" }}>
                <div class="col-6" style={{ textAlign: "left", height: "100%", padding: "0px" }}>
                    <img style={{ margin: "5px 25px", height: "45px" }} src={LogoImg} />
                    <span style={{ marginTop: "6px", position: "absolute", display: "inline-block", height: "30px" }}><Divider style={{ height: "30px" }} layout="vertical" /></span>
                    <LogoText>Snacking Data Quality Accelerator</LogoText>
                </div>
                <div style={{ padding: "0px", paddingRight: "15px", marginTop: "11px", textAlign: "right", height: "100%" }} class="col-6">
                    <Tooltip target=".custom-target-tooltip" content="Under construction, please check back soon" position="left" />
                    {/* onClick={()=>{navigate("/ruleElevation")}}  */}
                    <ActionText className=" custom-target-tooltip">
                        Rule Elevation
                    </ActionText>
                    <span class="vertical-divider"></span>  <ActionText className="handCursor custom-target-tooltip">
                        FAQ’s
                    </ActionText>
                    <span class="vertical-divider"></span>
                    <ActionText className="handCursor custom-target-tooltip">
                        Insights
                    </ActionText>
                    <span class="vertical-divider"></span>
                    <ActionText className="handCursor custom-target-tooltip">
                        My Requests
                        {/* <Badge style={{ marginLeft: "2px", backgroundColor: "white", color: theme.colors.primary }} size="normal" value="2"></Badge> */}
                    </ActionText>
                    <span class="vertical-divider"></span>
                    <Menu model={getBellNotification()
                    } style={{ width: "200px", maxHeight: "40%", overflow: "auto", padding: "0", margin: "0" }} popup ref={bellMenu} id="popup_menu_bell" />

                    <ActionText
                        aria-controls="popup_menu_bell" aria-haspopup
                        onClick={(event) => bellMenu.current.toggle(event)}
                        className="handCursor">
                        <i className="pi pi-bell" shape="circle" />
                    </ActionText>
                    {/* <ActionText className="handCursor custom-target-tooltip">
                        <i className="pi pi-bell" shape="circle" />
                    </ActionText> */}
                    <Menu model={[
                        {
                            label: localStorage.getItem("userName"),
                            items: [
                                {
                                    label: 'Access Management',
                                    command: () => {
                                        navigate("/accessManagement")
                                        // toast.current.show({ severity: 'success', summary: 'Success', detail: 'File created', life: 3000 });
                                    }
                                },
                                {
                                    label: 'Logout',
                                    command: () => {
                                        handleLogout()
                                    }
                                },
                                {
                                    label: <span style={{ overflowWrap: "anywhere" }}>{localStorage.getItem("userId")}</span>,
                                }
                            ]
                        }
                    ]
                    } popup ref={menuLeft} id="popup_menu_left" />
                    <Tooltip target=".avatar-target-icon" />
                    <Avatar className="avatar-target-icon handCursor"
                        image={photo}
                        data-pr-tooltip={localStorage.getItem("userName")}
                        data-pr-position="bottom"
                        aria-controls="popup_menu_left" aria-haspopup
                        onClick={(event) => menuLeft.current.toggle(event)}
                        style={{ verticalAlign: "top", top: "4px", position: "relative", backgroundColor: "#cbcbcb" }} icon={<FaUser />} shape="circle" />

                </div>
            </div>

        </HeaderComp>
    </Fragment>)
}
export default Header;
